/**
 * Thrown by `CmsClient.getPage` to signal a genuine content miss — no page exists for the requested
 * path — as distinct from a fetch/transport/config failure, which stays a plain `Error`.
 *
 * `getPage`'s return type stays `Promise<CmsPage>` (it still throws on any failure); this only gives
 * callers a type to branch on. See `resolve-cms-page.ts` (`@eneco/cms-next`) for the consumer.
 */
export class CmsPageNotFoundError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'CmsPageNotFoundError';
  }
}
